/** Hour options shown on the landing page hourly shoots section. */
export const HOURLY_LANDING_OPTIONS = [
    {
        hours: "0-3",
        title: "0-3 hour",
        tagline: "Short & Focused sessions",
    },
    {
        hours: "5",
        title: "5 hour",
        tagline: "Balanced & Versatile Production",
    },
    {
        hours: "8",
        title: "8 hour",
        tagline: "Full Scale Production",
    },
];
